export default __webpack_public_path__ + "static/boat-52f871a60999566d012332f87a919b0f.jpg";